module.exports = __webpack_public_path__ + "static/media/ticket.fd77e146.svg";